import { useLayoutEffect, useState } from "react";

import { InnerSize } from "./types";

const useInnerSize = (): InnerSize => {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  useLayoutEffect(() => {
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, []);

  return size;
};

export default useInnerSize;
